// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYER_HAS_SEEN_AD = "\u010c\u00edtal u\u017e z\u00e1ujemca tvoju spr\u00e1vu?";
export const SELLER_HAS_SEEN_AD = "\u010c\u00edtal u\u017e predajca tvoju spr\u00e1vu?";
